module.exports = __webpack_public_path__ + "img/user.09796cb4.svg";